// MUI
import Box from '@mui/material/Box'

// Custom
import HeroSection from './sections/HeroSection'
import WhyMattersSection from './sections/WhyMattersSection'
import AudienceSection from './sections/AudienceSection'
import TopicsSection from './sections/TopicsSection'
import TailoredSection from './sections/TailoredSection'
import FormatsSection from './sections/FormatsSection'
import TakeawaysSection from './sections/TakeawaysSection'
import GainsSection from './sections/GainsSection'
import CtaSection from './sections/CtaSection'

// Style
import themeColors from 'assets/theme/colors'

export default function OtAwarenessTrainingView() {
  // *** MAIN RENDER ***
  return (
    <Box sx={{ background: themeColors.kroemtech.background }}>
      {/* The hero is full bleed and carries the breadcrumbs itself, so it also
          owns the padding that clears the fixed header. */}
      <HeroSection />

      <WhyMattersSection />
      <AudienceSection />
      <TopicsSection />
      <TailoredSection />
      <FormatsSection />
      <TakeawaysSection />
      <GainsSection />
      <CtaSection />
    </Box>
  )
}
